import { useTranslation } from "react-i18next";
import TeambookDialog from "./TeambookDialog";
import PropTypes from "prop-types";

const WarningModal = ({ closeModal, onNo }) => {
  const { t } = useTranslation();

  return (
    <TeambookDialog
      onClose={closeModal}
      title={t("save_changes")}
      open={true}
      withCloseButton
      content={
        <p style={{whiteSpace: "pre-line"}}>{t("save_changes_text")}</p>
      }
      actionButtons={[
        {
          type: "outlined",
          text: t("exit_without_save"),
          onClick: onNo,
        },
        {
          text: t("continue_editing"),
          onClick: closeModal,
        },
      ]}
    />
  );
};

WarningModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
}

export default WarningModal;
